var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCacheshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 7.4V16.6M14.6 9.6C14 8.9 13 8.6 12 8.6C10.5 8.6 9.4 9.3 9.4 10.5C9.4 13.1 14.6 11.9 14.6 14.5C14.6 15.7 13.5 16.5 12 16.5C10.9 16.5 9.9 16.1 9.3 15.4",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCacheshare);
export default __webpack_public_path__ + "static/media/nav-cacheshare.b7b7bdb37f303897d14bc44c88347975.svg";
export { ForwardRef as ReactComponent };